export default __webpack_public_path__ + "static/media/In-Transit.188dc53f.png";